import { Text } from '@ldp-web/component-library/ui/atoms/text';
import React from 'react';
import { useIntl } from 'react-intl';
import styles from './pharmaprix-owners-footer.module.scss';

const PharmaprixOwnersFooter: React.FC = () => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.footer}>
      <Text>{formatMessage({ id: 'pharmaprixPharmacistsOwnersFooterTextTop' })}</Text>
      <Text>{formatMessage({ id: 'pharmaprixPharmacistsOwnersFooterTextBottom' })}</Text>
    </div>
  );
};

export default PharmaprixOwnersFooter;
